// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyList_faculty-list__toP6k {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}
.FacultyList_faculty-list__cards__SyCnH {
  padding: 16px 0px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-self: stretch;
}
.FacultyList_faculty-list__toP6k .FacultyList_results__wwrfu {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
  overflow: hidden;
}
.FacultyList_faculty-list__toP6k .FacultyList_results__header__IYRuW {
  display: flex;
  padding: 0px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
}
.FacultyList_faculty-list__toP6k .FacultyList_results__body__vYBRx {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  padding: 0 5px;
}
.FacultyList_faculty-list__toP6k .FacultyList_results--title__7fJqu {
  text-align: center;
  color: var(--accent-color);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.FacultyList_faculty-list__toP6k .FacultyList_results--description__iyuLZ {
  color: var(--grey-text);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.FacultyList_faculty-list__toP6k .FacultyList_results--controller__7PNqF {
  display: flex;
  padding: 0px;
  align-items: center;
  align-self: stretch;
}
.FacultyList_faculty-list__toP6k .FacultyList_results__header-controller__fVKCt {
  display: flex;
  padding: 0px 17px;
  justify-content: space-between;
  align-items: center;
  flex: 1 1;
  align-self: stretch;
  gap: 32px;
}
.FacultyList_faculty-list__toP6k .FacultyList_results--total__Lg4Dt {
  font-size: 14px;
  color: var(--grey-text);
}
.FacultyList_faculty-list__toP6k .FacultyList_compare-btn__MHkLS {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(30, 58, 95, 0.2);
}
.FacultyList_faculty-list__toP6k .FacultyList_compare-btn__MHkLS:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(30, 58, 95, 0.3);
  filter: brightness(110%);
}
.FacultyList_faculty-list__toP6k .FacultyList_compare-btn__MHkLS:active:not(:disabled) {
  transform: translateY(0);
}
.FacultyList_faculty-list__toP6k .FacultyList_compare-btn__MHkLS:disabled {
  background: #e0e0e0;
  color: #a0a0a0;
  cursor: not-allowed;
  box-shadow: none;
}
.FacultyList_faculty-list__toP6k .FacultyList_compare-btn__MHkLS svg {
  flex-shrink: 0;
}
.FacultyList_faculty-list__toP6k .FacultyList_right-section__7mYJY {
  max-width: 300px;
  width: 100%;
}
@media only screen and (max-width: 900px) {
  .FacultyList_faculty-list__toP6k {
    flex-direction: column;
    gap: 20px;
  }
  .FacultyList_faculty-list__toP6k .FacultyList_results__wwrfu {
    width: 100%;
  }
  .FacultyList_faculty-list__toP6k .FacultyList_results--title__7fJqu {
    font-size: 20px;
  }
  .FacultyList_faculty-list__toP6k .FacultyList_right-section__7mYJY {
    max-width: initial;
  }
}

.FacultyList_related-keywords-wrapper__sMb7Q {
  margin-bottom: 20px;
  animation: FacultyList_fadeIn__s6dty 0.3s ease-in-out;
}

.FacultyList_keyword-chips__x7lBs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.FacultyList_keyword-chip__sq\\+j5 {
  background-color: #f0f0f0;
  border-radius: 16px;
  padding: 5px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.FacultyList_keyword-chip__sq\\+j5:hover {
  background-color: #e0e0e0;
}

.FacultyList_no-results-message__i5IW6 {
  display: block;
  margin-bottom: 20px;
  font-size: 16px;
  color: #ff4d4f;
}

@keyframes FacultyList_fadeIn__s6dty {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.FacultyList_keyword-list__CrGq9 {
  list-style-type: none;
  padding: 0;
}
.FacultyList_keyword-list__CrGq9 li {
  cursor: pointer;
  margin-bottom: 5px;
}
.FacultyList_keyword-list__CrGq9 li:hover {
  text-decoration: underline;
}

.FacultyList_keyword-stats-selector__x5CEV {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.FacultyList_card__Mk03D {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.FacultyList_card__Mk03D:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(30, 58, 95, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Benchmarking/FacultyList.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AACF;AACE;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AACJ;AAEE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AADN;AAII;EACE,kBAAA;EACA,0BAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAKI;EACE,uBAAA;EACA,kBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAMI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAJN;AAOI;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;AALN;AAQI;EACE,eAAA;EACA,uBAAA;AANN;AAUE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,6DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,4CAAA;AARJ;AAUI;EACE,2BAAA;EACA,4CAAA;EACA,wBAAA;AARN;AAWI;EACE,wBAAA;AATN;AAYI;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAVN;AAaI;EACE,cAAA;AAXN;AAeE;EACE,gBAAA;EACA,WAAA;AAbJ;AAgBE;EA/HF;IAgII,sBAAA;IACA,SAAA;EAbF;EAeE;IACE,WAAA;EAbJ;EAeI;IACE,eAAA;EAbN;EAiBE;IACE,kBAAA;EAfJ;AACF;;AAmBA;EACE,mBAAA;EACA,qDAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAhBF;AAkBE;EACE,yBAAA;AAhBJ;;AAoBA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAjBF;;AAoBA;EACE;IACE,UAAA;IACA,4BAAA;EAjBF;EAoBA;IACE,UAAA;IACA,wBAAA;EAlBF;AACF;AAqBA;EACE,qBAAA;EACA,UAAA;AAnBF;AAqBE;EACE,eAAA;EACA,kBAAA;AAnBJ;AAqBI;EACE,0BAAA;AAnBN;;AAwBA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,oCAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,mBAAA;EACA,iDAAA;AArBF;AAuBE;EACE,2BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mCAAA;AArBJ","sourcesContent":[".faculty-list {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 40px;\n\n  &__cards {\n    padding: 16px 0px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    align-self: stretch;\n  }\n\n  .results {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 40px;\n    align-self: stretch;\n    overflow: hidden;\n\n    &__header {\n      display: flex;\n      padding: 0px 40px;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 12px;\n      align-self: stretch;\n    }\n\n    &__body {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 16px;\n      align-self: stretch;\n      padding: 0 5px;\n    }\n\n    &--title {\n      text-align: center;\n      color: var(--accent-color);\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    &--description {\n      color: var(--grey-text);\n      text-align: center;\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n\n    &--controller {\n      display: flex;\n      padding: 0px;\n      align-items: center;\n      align-self: stretch;\n    }\n\n    &__header-controller {\n      display: flex;\n      padding: 0px 17px;\n      justify-content: space-between;\n      align-items: center;\n      flex: 1;\n      align-self: stretch;\n      gap: 32px; // more space\n    }\n\n    &--total {\n      font-size: 14px;\n      color: var(--grey-text);\n    }\n  }\n\n  .compare-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 18px;\n    border-radius: 12px;\n    border: none;\n    background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);\n    color: #fff;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 4px 12px rgba(30, 58, 95, 0.2);\n\n    &:hover:not(:disabled) {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 16px rgba(30, 58, 95, 0.3);\n      filter: brightness(110%);\n    }\n\n    &:active:not(:disabled) {\n      transform: translateY(0);\n    }\n\n    &:disabled {\n      background: #e0e0e0;\n      color: #a0a0a0;\n      cursor: not-allowed;\n      box-shadow: none;\n    }\n\n    svg {\n      flex-shrink: 0;\n    }\n  }\n\n  .right-section {\n    max-width: 300px;\n    width: 100%;\n  }\n\n  @media only screen and (max-width: 900px) {\n    flex-direction: column;\n    gap: 20px;\n\n    .results {\n      width: 100%;\n\n      &--title {\n        font-size: 20px;\n      }\n    }\n\n    .right-section {\n      max-width: initial;\n    }\n  }\n}\n\n.related-keywords-wrapper {\n  margin-bottom: 20px;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.keyword-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.keyword-chip {\n  background-color: #f0f0f0;\n  border-radius: 16px;\n  padding: 5px 12px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n\n  &:hover {\n    background-color: #e0e0e0;\n  }\n}\n\n.no-results-message {\n  display: block;\n  margin-bottom: 20px;\n  font-size: 16px;\n  color: #ff4d4f;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.keyword-list {\n  list-style-type: none;\n  padding: 0;\n\n  li {\n    cursor: pointer;\n    margin-bottom: 5px;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.keyword-stats-selector {\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.card {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 16px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    background: rgba(255, 255, 255, 0.9);\n    border-color: rgba(30, 58, 95, 0.1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-list": `FacultyList_faculty-list__toP6k`,
	"faculty-list__cards": `FacultyList_faculty-list__cards__SyCnH`,
	"results": `FacultyList_results__wwrfu`,
	"results__header": `FacultyList_results__header__IYRuW`,
	"results__body": `FacultyList_results__body__vYBRx`,
	"results--title": `FacultyList_results--title__7fJqu`,
	"results--description": `FacultyList_results--description__iyuLZ`,
	"results--controller": `FacultyList_results--controller__7PNqF`,
	"results__header-controller": `FacultyList_results__header-controller__fVKCt`,
	"results--total": `FacultyList_results--total__Lg4Dt`,
	"compare-btn": `FacultyList_compare-btn__MHkLS`,
	"right-section": `FacultyList_right-section__7mYJY`,
	"related-keywords-wrapper": `FacultyList_related-keywords-wrapper__sMb7Q`,
	"fadeIn": `FacultyList_fadeIn__s6dty`,
	"keyword-chips": `FacultyList_keyword-chips__x7lBs`,
	"keyword-chip": `FacultyList_keyword-chip__sq+j5`,
	"no-results-message": `FacultyList_no-results-message__i5IW6`,
	"keyword-list": `FacultyList_keyword-list__CrGq9`,
	"keyword-stats-selector": `FacultyList_keyword-stats-selector__x5CEV`,
	"card": `FacultyList_card__Mk03D`
};
export default ___CSS_LOADER_EXPORT___;
